import { AppConfigDev } from "./index.dev";
import { AppConfigProd } from "./index.prod";
var app_mode = "prod";
export const config = app_mode === "dev" ? AppConfigDev : AppConfigProd;
